module.exports = __webpack_public_path__ + "files/2702ac35e78692e600011ed1c85ef060.eot";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_Main-Italic.eot
// module id = 430
// module chunks = 60